import { render, staticRenderFns } from "./InputNewFact.vue?vue&type=template&id=b670c9fc"
import script from "./InputNewFact.vue?vue&type=script&lang=js"
export * from "./InputNewFact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports